import * as _ from 'lodash';
import * as WordWrap from 'word-wrap';

import { Formatters } from 'src/common/formatters';
import { getComponentSortFields } from './component-sorting';

// Configuration
const MAX_COMPONENT_NAME_LEN_WRAP = 41;
const MAX_COMPONENTY_QUANTITY_LEN_WRAP = 24;

const determineIdealBalance = (dataItem: any, avgCost: number) => {
    let idealBal = 0.0;
    if (dataItem.usefulLife === 'N/A') {
        return idealBal;
    } else if (dataItem.usefulLife === 9999 || dataItem.usefulLife === '1TE') {
        const oteUsefulLife = dataItem.remainingUsefulLife + 1;
        if (dataItem.remainingUsefulLife > 0) {
            idealBal = avgCost * (oteUsefulLife - dataItem.remainingUsefulLife) / oteUsefulLife;
        } else {
            idealBal = avgCost;
        }
    } else if (!dataItem.remainingUsefulLife) {
        idealBal = avgCost;
    } else if (dataItem.remainingUsefulLife <= dataItem.usefulLife) {
        idealBal = avgCost * ((dataItem.usefulLife - dataItem.remainingUsefulLife) / dataItem.usefulLife);
    }
    return idealBal;
};

const extendDataItem = (mrcValue: number, dataItem: any, sumAvgCostsPerUL: number = 0, availableBalance: number = 0, excessFunds: number = 0) => {

    const avgCost = _.get(dataItem, 'avgCost_sort', 0);
    const invExpenditure = _.get(dataItem, 'expenditureMap[0]');
    const idealBal = determineIdealBalance(dataItem, avgCost);
    let avgCostPerUL = _.get(invExpenditure, 'signAsDollar', 0);
    const subgroup = _.get(dataItem, 'subgroup', '');

    // Allocate the full cost iff it is available, otherwise all that is remaining
    let currentFundBalance = (idealBal <= availableBalance) ? idealBal : availableBalance;
    if (excessFunds > 0 && _.get(dataItem, 'usefulLife', 0) > 0) {
        currentFundBalance += excessFunds;
    }
    let monthly = 0;
    if (mrcValue > 0 && avgCostPerUL > 0 && sumAvgCostsPerUL > 0) {
        monthly = mrcValue * (avgCostPerUL / sumAvgCostsPerUL);
    }
    if (dataItem.usefulLife === 'N/A') {
        monthly = 0.0;
        avgCostPerUL = 0.0;
    }

    let res = {
        avgCost: avgCost,
        idealBal: idealBal,
        curBal: currentFundBalance,
        currentFundBalance: currentFundBalance,
        cfi_curFundBalance: currentFundBalance,
        monthly: monthly,
        subgroup: subgroup,
        signAsDollar: avgCostPerUL,
        wrappedItemRow: false,
        wrappedItemRow_sort: '',
    };

    return { lineItem: res, remainingBalance: availableBalance - currentFundBalance };
};

export const transformComponentFundingItems = (dataItems: any[], startingBalance: number, mrcValue: number) => {
    const sumAvgCostsPerUL = _.sumBy(dataItems, 'expenditureMap[0].signAsDollar');
    const orderedDataItems = _.orderBy(dataItems, ['remainingUsefulLife_sort', 'avgCost'], ['asc', 'asc']);
    const idealFullBalance = _.sum(_.map(dataItems, (item) => {
        const avgCost = _.get(item, 'avgCost_sort', 0);
        return !item.remainingUsefulLife ? avgCost : (item.remainingUsefulLife >= item.usefulLife) ? 0 : avgCost * ((item.usefulLife - item.remainingUsefulLife) / item.usefulLife);
    }));
    const numItemsToFund = _.filter(dataItems, (item) => {
        if (item.usefulLife > 0) {
            return true;
        }
        return false;
    }).length;
    const percentFunded = startingBalance / idealFullBalance;
    const excessFunds = (percentFunded > 1.000) ? Math.round(100 * ((startingBalance - idealFullBalance) / numItemsToFund)) / 100 : 0;
    let availableBalance = startingBalance;

    let results: any[] = _(orderedDataItems)
        .map((inv, invInd) => {
            const extendedData = extendDataItem(mrcValue, inv, sumAvgCostsPerUL, availableBalance, excessFunds);
            const itemCompName = _.trim(Formatters.getStr(inv, 'componentName'));
            const extendedLineItem = extendedData.lineItem;
            const componentSortFields = getComponentSortFields(inv, invInd);
            availableBalance = extendedData.remainingBalance;

            const item = {
                _id: Formatters.getStr(inv, '_id'),
                componentId: componentSortFields.__componentDisplayId,
                componentName: itemCompName,
                componentName_sort: itemCompName.toLowerCase(),
                quantity: Formatters.getStr(inv, 'quantity'),
                remainingUsefulLife: Formatters.getStr(inv, 'remainingUsefulLife'),
                remainingUsefulLife_sort: Formatters.getInt(inv, 'remainingUsefulLife'),
                usefulLife: Formatters.getStr(inv, 'usefulLife'),
                idealBal: Formatters.getFloat(inv, 'idealBal'),
                signAsDollar: Formatters.getFloat(inv, 'signAsDollar'),
            };

            const res = _.merge({}, item, extendedLineItem, componentSortFields);

            return res;
        })
        .value();

    return results;
    // let resultsExpanded = _.stubArray();
    // for (let iItemInd = 0; iItemInd < _.size(results); iItemInd++) {
    //     let r = results[iItemInd];
    //     let rItem = _.cloneDeep(r);

    //     resultsExpanded.push(rItem);
    // }
    // return resultsExpanded;
};



// WEBPACK FOOTER //
// ./src/report/componentFunding.tsx